<template>
  <div class="log-box">
    <div class="title">操作记录</div>
    <div class="table">
      <el-table :data="auditRecordVoList" tooltip-effect="dark" height="100%" :header-cell-style="{background: '#FAFAFA', color: '#222222'}">
        <el-table-column prop="createTime" label="时间" width="220"></el-table-column>
        <el-table-column prop="operateRecord" label="操作记录" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operateName" label="操作人" width="180"></el-table-column>
        <div slot="empty">
          <img style="width: 200px; height: 130px;" src="@/assets/img/common/tableNoData.png" alt="">
          <p>暂无数据</p>
        </div>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['auditRecordVoList'],
  data() {
    return {
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
<style lang="less" scoped>
.log-box {
  width: 900px;
  padding: 0 24px;
  box-sizing: border-box;

  .title {
    margin-top: 24px;
    font-size: 14px;
    font-family: SourceHanSansSC-Medium, SourceHanSansSC;
    font-weight: 500;
    color: #222222;
  }

  .table {
    margin-top: 14px;
    margin-bottom: 24px;
  }
}
</style>